<div class="container px-5 text-center">
    <div class="justify-content-center mt-3">
        <div class="card bg-dark rounded shadow border-primary">
            <div class="card-body">
                <div class="row">
                    <div class="col-6">
                        <img [src]="user.image? host+'/storage/images/users/'+user.image : 'assets/avatar.png'"
                            class="img-thumbnail img-profile rounded-circle" style="width:8rem; height:8rem;"
                            alt="profile">
                    </div>
                    <div class="col-6">
                        <h5 class="mt-3 text-wrap overflow-hidden card-title text-white">{{user.name}}</h5>
                        <h6 class="col text-white-50 m-0 p-0 text-center">{{ user.role?.name }}</h6> 
                        <h6 class="col m-0 p-0 text-center" [ngClass]="offlineMode? 'text-danger' : 'text-success'">{{ offlineMode? 'Offline' : 'Online' }}</h6>
                        <p class="mt-1 text-white-50">Scanned: {{ scan_counter }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="justify-content-center mt-3" *ngIf="currentEvents.length > 0">
        <div class="card bg-dark rounded shadow border-primary">
            <div class="card-body">


                <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
                    <div class="carousel-inner">
                        <div class="carousel-item" *ngFor="let event of currentEvents; let i = index"
                            [ngClass]="{'active': i === 0}">
                            <div class="row">
                                <div class="col-6">
                                    <img src="{{host}}/storage/images/events/{{(event.image? event.image : event.image_secondary )}}"
                                        style="object-fit:cover;" class="w-100 h-100">
                                </div>
                                <div class="col-6 text-white pt-2">
                                    <h6>{{(event.name.length>40)? (event.name | slice:0:40)+'...':(event.name)}}</h6>
                                    <div class="text-white-50" style="font-size: 10px;">{{ 'menu.entrance_start' |
                                        translate }}: {{ event.entrance_start | date : "HH:mm" }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls"
                        data-bs-slide="prev">

                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls"
                        data-bs-slide="next">

                        <span class="visually-hidden">Next</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <hr [ngClass]="currentEvents.length > 0? 'my-3' : 'my-5'">

    <div class="mb-5">
        <a class="btn btn-success btn-lg w-100 mb-4 fw-bold text-white" routerLink="/ticket"><i
                class="bi bi-qr-code"></i> {{ 'menu.scan' | translate }}</a>
        <a class="btn btn-info w-100 mb-4 text-white" routerLink="/sale"><i
                    class="bi bi-cart-plus"></i> {{ 'menu.sell' | translate }}</a>        
        <a class="btn btn-warning w-100 mb-4 text-white" routerLink="/check"><i class="bi bi-ticket-perforated"></i> {{
            'menu.check' | translate }}</a>
        <a class="btn btn-secondary w-100 mb-4" routerLink="/options"><i class="bi bi-gear"></i> {{ 'menu.options' |
            translate }}</a>
        <a class="btn btn-danger w-100 mb-4 text-white" (click)="logout()"><i class="bi bi-box-arrow-right"></i> {{
            'menu.logout' | translate }}</a>
    </div>
</div>